import { useState } from "react"
import { useEffect } from "react"
import { Controller, useForm, useWatch } from "react-hook-form"
import { colourStyles } from "../../../Utils/styled-components/react-select.style"
import useTerritory from "../Context/hook/useTerritory"
import Select from 'react-select'
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai"
import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";

export const BranchOffice = ({ onAdd, onEdit, onClose, patchValue }) => {
    const { control, formState: { errors }, watch, register, setValue, getValues, handleSubmit, reset } = useForm({
        defaultValues: {
            id: 0
        },
        shouldUnregister: true,
        mode: 'onBlur'
    })

    const [formMode, setFormMode] = useState("NEW")

    const { fetchDistricts, fetchMunicipalities, fetchProvinces, loadingSet, territories } = useTerritory()

    const watchProvince = useWatch({control, name: 'provincia'})
    const watchMunicipality = useWatch({control, name: 'municipio'})

    useEffect(() => {
        if(patchValue.state) reset(patchValue.state)
        setFormMode((cur) => patchValue.index !== null ? "EDIT" : "NEW")
        fetchProvinces()  
    }, [])

    useEffect(() => {
        cascadeDropdown()        
    }, [watchMunicipality, watchProvince])

    const cascadeDropdown = async () => {
        if(watchProvince) await fetchMunicipalities(watchProvince)
        if(watchMunicipality) await fetchDistricts(watchMunicipality, watchProvince)
    } 
    
    const submitForm = (formValue, event) => {
        event.stopPropagation()
        event.preventDefault()
        const cleanedValues = {
            ...formValue,
        }
        formMode === 'EDIT' ? onEdit(cleanedValues, patchValue.index) : onAdd(cleanedValues)
        onClose(false)
    }

    return (
        <div className="">
            <form className="custom-form grid grid-cols-1 tab-port:grid-cols-4 small-desktop:grid-cols-[repeat(8,1fr)] 
                gap-x-8 px-8"
                // onSubmit={handleSubmit(submitForm)}
                >
                <input type="hidden" {...register('id',
                    { required: { message: 'El id es requerido', value: true } }
                )} />
                <div className="custom-form__control col-span-full">
                    <label className='custom-form__label' htmlFor="nombre">
                        Nombre
                        <span className="text-danger"> *</span>
                    </label>
                    <input className='custom-form__input' id="nombre" type="text"
                        {...register('nombre',
                            { required: { message: 'Este campo es requerido', value: true } }
                        )} />
                    <span>
                        {errors.nombre?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.nombre?.message}</p>}
                    </span>
                </div>
                <div className="custom-form__control col-span-full">
                    <label className='custom-form__label' htmlFor="direccion">
                        Dirección
                        <span className="text-danger"> *</span>
                    </label>
                    <textarea className="custom-form__input" id="direccion" cols="30" rows="3"
                        {...register('direccion',
                            {
                                required: { message: 'Este campo es requerido', value: true }
                            })} />
                    <span>
                        {errors.direccion?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.direccion?.message}</p>}
                    </span>
                </div>

                <div className="custom-form__control col-span-full tab-port:col-span-2">
                    <label className='custom-form__label'>
                        Provincia
                        <span className="text-danger"> *</span>
                    </label>
                    <Controller
                        control={control}
                        name="provincia"
                        rules={{ required: { value: true, message: 'Este campo es requerido' } }}
                        render={({
                            field: { onChange, name, value, ref, onBlur },
                        }) => (
                            <Select
                                ref={ref}
                                onBlur={onBlur}
                                styles={colourStyles}
                                // menuPlacement="top"
                                noOptionsMessage={() => "Sin datos"}
                                placeholder="Seleccione una provincia"
                                isLoading={loadingSet.provinces}
                                getOptionLabel={(option) => option?.name}
                                getOptionValue={(option) => option?.code}
                                options={territories.provinces}
                                onChange={(newValue) => {
                                    onChange(newValue?.code)
                                    setValue("municipio", null)
                                    setValue("ciudad", null)
                                }}
                                value={territories.provinces?.find(c => c?.code === value) ?? null}
                            />
                        )}>
                    </Controller>
                    <span>
                        {errors.provincia?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.provincia?.message}</p>}
                    </span>
                </div>

                <div className="custom-form__control col-span-full tab-port:col-span-2">
                    <label className='custom-form__label'>
                        Municipio
                        <span className="text-danger"> *</span>
                    </label>
                    <Controller
                        control={control}
                        name="municipio"
                        rules={{ required: { value: true, message: 'Este campo es requerido' } }}
                        render={({
                            field: { onChange, name, value, ref, onBlur },
                        }) => (
                            <Select
                                ref={ref}
                                onBlur={onBlur}
                                styles={colourStyles}
                                // menuPlacement="top"
                                noOptionsMessage={() => "Sin datos"}
                                placeholder="Seleccione un municipio"
                                getOptionLabel={(option) => option?.name}
                                getOptionValue={(option) => option?.code}
                                options={territories.municipalities}
                                isLoading={loadingSet.municipalities}
                                onChange={(newValue) => {
                                    onChange(newValue?.code)
                                    setValue("ciudad", null)
                                }}
                                value={territories.municipalities?.find(c => c?.code === value) ?? null}
                            />
                        )}>
                    </Controller>
                    <span>
                        {errors.municipio?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.municipio?.message}</p>}
                    </span>
                </div>

                <div className="custom-form__control col-span-full tab-port:col-span-2">
                    <label className='custom-form__label'>
                        Ciudad o Sección
                        <span className="text-danger"> *</span>
                    </label>
                    <Controller
                        control={control}
                        name="ciudad"
                        rules={{ required: { value: true, message: 'Este campo es requerido' } }}
                        render={({
                            field: { onChange, name, value, ref, onBlur },
                        }) => (
                            <Select
                                ref={ref}
                                onBlur={onBlur}
                                styles={colourStyles}
                                // menuPlacement="top"
                                noOptionsMessage={() => "Sin datos"}
                                placeholder="Seleccione un ciudad"
                                isLoading={loadingSet.districts}
                                getOptionLabel={(option) => option?.name}
                                getOptionValue={(option) => option?.code}
                                options={territories.districts}
                                onChange={(newValue) => {
                                    onChange(newValue?.code)
                                }}
                                value={territories.districts?.find(c => c?.code === value) ?? null}
                            />
                        )}>
                    </Controller>
                    <span>
                        {errors.ciudad?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.ciudad?.message}</p>}
                    </span>
                </div>

                <div className="custom-form__control col-span-full tab-port:col-span-2">
                    <label className='custom-form__label' htmlFor="paraje">
                        Paraje
                    </label>
                    <input className='custom-form__input' id="paraje" type="text"
                        {...register('paraje')} />
                </div>

                <div className="custom-form__control col-span-full tab-port:col-span-2">
                    <label className='custom-form__label' htmlFor="numeroLicencia">
                        Número de Autorización Ambiental

                    </label>
                    <input className='custom-form__input w-full' id="numeroLicencia" type="text"
                        {...register('numeroLicencia')} />
                </div>

                <button
                    onClick={handleSubmit(submitForm)}
                    className="col-span-full mt-8 mb-4 py-4 px-28 text-2xl bg-[#003670] text-white rounded-lg"
                >
                    Agregar
                </button>
            </form>
        </div>
    )
}

export const BranchOfficeList = ({ rows = [], onDelete, onEdit }) => {

    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(null);

    const handleDialog = (option) => {
        setOpen((cur) => option);
    };

    const DeleteModal = () => (
        <Dialog open={open} onClose={() => handleDialog(false)}>
          <DialogTitle id="alert-dialog-title">
            {"¿Estás seguro que deseas borrar esta sucursal?"}
          </DialogTitle>
          <DialogActions>
            <Button
              onClick={() => {
                setIndex(cur => null)
                handleDialog(false);
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={() => {
                onDelete(index);
                setIndex(cur => null)
                handleDialog(false);
              }}
              autoFocus
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      );

    const ActionButtons = ({index}) => (
        <div className="flex gap-x-4 items-center">
            <button
                onClick={() => onEdit(index)}
                className="py-2 px-6 text-3xl border border-warning text-warning rounded-lg
                 hover:bg-warning hover:text-white">
                <AiOutlineEdit />
            </button>
            <button
                onClick={() => {handleDialog(true); setIndex(cur => index)}}
                className="py-2 px-6 text-3xl border border-danger text-danger rounded-lg
                hover:bg-danger hover:text-white"
            >
                <AiOutlineDelete />
            </button>
        </div>
    )

    return (
        <div className="col-span-full border-2 border-bd bg-[#F2F2F2] p-0.5 rounded-md">
            <DeleteModal />
            <div className="flex flex-wrap gap-x-2">
                {rows?.length > 0 && rows.map((row, i) => (
                    <div key={i} className="flex items-center gap-x-20 justify-between text-3xl font-semibold py-2 px-4 
                        text-font-primary bg-white border border-bd-light">
                        <span>{row.nombre}</span>
                        <ActionButtons index={i} />
                    </div>
                ))}
            </div>
        </div>
    )
}